export default __webpack_public_path__ + "static/media/html.91c24f93.png";